import styled, { css } from 'styled-components';

import {
  CATALOG_SIDE_PADDING_V2,
  catalogPaddingStyle,
} from '~/src/screens/App/CatalogLayout/layout';
import { media, NAV_HEIGHT, zIndex } from '~/src/styles-constants';

export const Container = styled.nav`
  display: block;
  background: ${({ theme }) => theme.palette.common.WHITE};

  ${media.XL`
    position: sticky;
    top: ${NAV_HEIGHT}px;
    z-index: ${zIndex.familiesMenu};
  `}
`;

/**
 * Le titre n'est affiché qu'en mobile, mais est toujours présent dans le DOM
 */
export const Title = styled.h1`
  display: block;
  margin: 0;
  padding-top: 8px;
  ${catalogPaddingStyle}

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  ${media.XL`
    font-size: 20px;
    line-height: 24px;
  `}
`;

/** Placeholder desktop si les familles ne sont pas chargées */
export const Placeholder = styled.div`
  ${({ theme }) => css`
    height: 128px;
    border: solid ${theme.palette.common.WHITE};
    border-width: 8px ${CATALOG_SIDE_PADDING_V2}px;
    background: ${theme.palette.common.WHITE}
      repeating-linear-gradient(
        to left,
        ${theme.palette.common.BACKGROUND_4},
        ${theme.palette.common.BACKGROUND_4} calc((100% - 64px) / 5),
        ${theme.palette.common.TRANSPARENT} calc((100% - 64px) / 5),
        ${theme.palette.common.TRANSPARENT} calc((100% - 64px) / 5 + 16px)
      );
  `}
`;
